// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2goAf","label":"styles_label__3vZdZ"};